import { useEffect } from 'react';

/**
 * The Quicksand / Comfortaa faces the email editors and the Library text tool
 * draw with. Loaded when an editor opens rather than from index.html: a
 * render-blocking stylesheet on a third-party host would delay first paint of
 * every page, including the public storefront, which never uses these faces.
 */
const EDITOR_FONTS_HREF = 'https://fonts.googleapis.com/css2?family=Comfortaa:wght@400;500;700&family=Quicksand:wght@400;500;700&display=swap';
const EDITOR_FONTS_LINK_ID = 'editor-fonts';

export function ensureEditorFonts(): void {
  try {
    if (typeof document === 'undefined' || document.getElementById(EDITOR_FONTS_LINK_ID)) return;
    const link = document.createElement('link');
    link.id = EDITOR_FONTS_LINK_ID;
    link.rel = 'stylesheet';
    link.href = EDITOR_FONTS_HREF;
    document.head.appendChild(link);
  } catch {
    // Fonts are cosmetic: the editors fall back to their system font stacks.
  }
}

export function useEditorFonts(): void {
  useEffect(() => { ensureEditorFonts(); }, []);
}
